import style from './Item.module.scss'

interface IProps {
    title: string
    descriptions: string
    template: string
    onAddMarkdownTemplate: (template: string) => void
}

export const Item = (props: IProps) => {
    const { title, template, onAddMarkdownTemplate } = props
    return (
        <div className={style.container} onClick={() => onAddMarkdownTemplate(template)}>
            <div className={style.blockHeader}>
                <span>{title}</span>
            </div>
            {/* <hr className={style.hr} />
            <div className={style.blockDescriptions}>
                <span>{descriptions}</span>
            </div> */}
        </div>
    )
}
